import { Text, useIsMobile } from '@yes.technology/react-toolkit'
import { lazy, Suspense } from 'react'
import { SafeHtmlContent } from 'site/shared/components/SafeHtmlContent'
import { TextContainer } from './TabsContent.styles'
import { TabsContentItemProps } from './TabsContent.types'

const LazyLoadComponent = lazy(() => import('site/Renderer/LoadComponent'))

function TabsContentItem({
  currentKey,
  items,
  textColor
}: TabsContentItemProps) {
  const isMobile = useIsMobile()

  const currentItem = items[currentKey]

  if (!currentItem) return null

  if (currentItem.components) {
    return (
      <Suspense fallback={<></>}>
        <LazyLoadComponent components={currentItem.components} />
      </Suspense>
    )
  }

  return (
    <TextContainer>
      <Text variant={isMobile ? 'content-03' : 'content-04'} color={textColor}>
        <SafeHtmlContent html={currentItem?.complement} />
      </Text>
    </TextContainer>
  )
}

export default TabsContentItem
